import EjectButton from './eject-button.js';
import HistoryButton from '../../history-button/index.js';
import MyPasskeyButton from '../../my-passkey-button/index.js';
import SettingsButton from '../../settings-button/index.js';
import ToggleButton from '../../toggle-button/index.js';

function FixedHeader() {
  return (
    <header className="flex size-full items-center justify-between">
      <MyPasskeyButton />
      <div className="flex items-center gap-x-2">
        <HistoryButton />
        {!__STANDALONE_MODE__ && <EjectButton />}
        {__STANDALONE_MODE__ ? <SettingsButton /> : <ToggleButton />}
      </div>
    </header>
  );
}

export default FixedHeader;
